import { render } from "./zzsdzptfptxf.vue?vue&type=template&id=2ee3c2a5&scoped=true"
import script from "./zzsdzptfptxf.vue?vue&type=script&lang=js"
export * from "./zzsdzptfptxf.vue?vue&type=script&lang=js"

import "./zzsdzptfptxf.vue?vue&type=style&index=0&id=2ee3c2a5&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee3c2a5"]])

export default __exports__